export default __webpack_public_path__ + "static/media/basil_unlock-solid.e13a4e57.svg";